import { request } from "../../apis";
import { getCurrency } from "../../plugins/utils";

const currentCurrency = getCurrency();

//bet inquiry
export const apiGetBetRecord = (params) =>
  request("get", `/${currentCurrency}/agent/bet/detail`, params, true);

export const apiGetGameList = () =>
  request("get", `/${currentCurrency}/game/setting`, {}, true);

export const apiGetSubGameList = (gameCode) =>
  request("get", `/${currentCurrency}/game/${gameCode}/list`, {}, true);

